export class NavigationError extends Error {
  constructor(message: string) {
    super(`[@sail/navigation] ${message}`);
  }
}
